/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';

interface IArgs {
  haveNoConnections: boolean;
  airdnaRedirectClick: boolean;
  isSubmitting: boolean;
  onCta: () => void;
}

interface UiCompSetsPromoSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

export default class UiCompSetsPromoComponent extends Component<UiCompSetsPromoSignature> {
  @cached
  get ctaTranslationKey(): string {
    let base = 'comp_sets.actionable_section.cta.';

    if (this.args.haveNoConnections) {
      base += 'connect_airbnb';
    } else if (this.args.airdnaRedirectClick) {
      base += 'go_to_airdna';
    } else {
      base += 'optimize_revenue';
    }

    return base;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::CompSets::Promo': typeof UiCompSetsPromoComponent;
  }
}
